'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var settings = require('@pixi/settings');
var constants = require('@pixi/constants');

settings.settings.PREFER_ENV = constants.ENV.WEBGL2;
settings.settings.STRICT_TEXTURE_CACHE = false;

Object.defineProperty(exports, 'settings', {
	enumerable: true,
	get: function () { return settings.settings; }
});
//# sourceMappingURL=settings.js.map
